<template>
  <div>
    <div class="row">
      <div class="col-md-3 sidebar">
        <div style="clear: both;"></div>
        <router-link
          :to="{ name: 'playlistWatch', params: { id: $route.params.id } }"
          class="play-all-container"
        >
          <div class="play-all" :style="{ background: getPoster(form.thumbnail) }">
            <div class="btn-play-all">
              <md-icon> <v-icon name="play" /> </md-icon>Play All
            </div>
          </div>
        </router-link>
        <form novalidate class="md-layout" ref="form" @submit.stop.prevent="checkFormValidity">
          <md-card class="md-layout-item">
            <md-card-content>
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                  <md-field :class="getValidationClass('name')">
                    <label for="name">Name</label>
                    <md-input
                      name="name"
                      id="name"
                      autocomplete="given-name"
                      v-model="form.name"
                      :disabled="sending"
                    />
                    <span class="md-error" v-if="!$v.form.name.required">The name is required</span>
                    <span class="md-error" v-else-if="!$v.form.name.minlength"
                      >Playlist must be at least 3 characters.</span
                    >
                  </md-field>
                  <md-menu md-size="medium" md-align-trigger>
                    <md-button class="md-icon-button" md-menu-trigger>
                      <v-icon name="ellipsis-h" />
                    </md-button>
                    <md-menu-content>
                      <md-list>
                        <md-list-item v-b-modal.select-videos href="#">
                          <v-icon tag="md-icon" name="plus" />
                          <span>Add Videos</span>
                        </md-list-item>
                        <md-list-item @click="deletePlaylist()">
                          <v-icon tag="md-icon" name="trash" />
                          <span>Delete Playlist</span>
                        </md-list-item>
                      </md-list>
                    </md-menu-content>
                  </md-menu>
                  <md-field :class="getValidationClass('description')">
                    <label for="description">Description</label>
                    <md-input
                      name="description"
                      id="description"
                      v-model="form.description"
                      :disabled="sending"
                    />
                    <span class="md-error" v-if="!$v.form.description.required"
                      >The description is required</span
                    >
                    <span class="md-error" v-else-if="!$v.form.description.minlength"
                      >Description must be at least 5 characters.</span
                    >
                  </md-field>
                </div>
              </div>
            </md-card-content>
            <md-progress-bar md-mode="indeterminate" v-if="sending" />
            <md-card-actions>
              <md-button type="submit" class="md-primary" :disabled="sending">Save</md-button>
            </md-card-actions>
          </md-card>
        </form>
      </div>
      <div class="col-md-9">
        <div class="text-center mt-5" v-if="form.selectedVideos.length <= 0">
          <h1>Please add Videos to playlist</h1>
          <b-button v-b-modal.select-videos>Add Videos</b-button>
        </div>

        <div v-else class="playlist-select">
          <draggable
            tag="ul"
            v-if="form.selectedVideos.length > 0"
            v-model="form.selectedVideos"
            handle=".handle"
            class="mt-4 list-full"
          >
            <li class="" v-for="video in form.selectedVideos" v-bind:key="video.Id">
              <div>
                <div class="video">
                  <div class="handle">
                    <md-icon> <v-icon name="align-justify" color="#000" /> </md-icon>
                  </div>
                  <div class="poster" :style="{ background: getPoster(video) }"></div>
                  <div>
                    <p>{{ video.name }}</p>
                    <p class="time">
                      <vue-moments-ago prefix suffix="ago" :date="video.date" lang="en" />
                    </p>
                  </div>
                </div>
                <div style="clear: both;"></div>
              </div>
            </li>
          </draggable>
        </div>
      </div>
    </div>
    <b-modal id="select-videos" ref="select-videos" title="Select Videos" @ok="handleOk">
      <form ref="form" class="playlist-select" @submit.stop.prevent="handleOk">
        <ul class="pt-4" v-if="videos.length > 0">
          <li
            class="videos"
            v-for="video in videos"
            v-bind:key="video._id"
            v-bind:class="{ active: form.selectedVideos.some(e => e._id === video._id) }"
          >
            <div v-on:click="toggleSelected(video)">
              <div class="video">
                <div class="poster" :style="{ background: getPoster(video) }"></div>
                <p>{{ video.name }}</p>
                <p class="time">
                  <vue-moments-ago prefix suffix="ago" :date="video.date" lang="en" />
                </p>
              </div>
              <div style="clear: both;"></div>
            </div>
          </li>
        </ul>
      </form>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import Axios from "axios";
import VueMomentsAgo from "vue-moments-ago";
import draggable from "vuedraggable";

export default {
  components: {
    VueMomentsAgo,
    draggable
  },
  mixins: [validationMixin],
  data: () => ({
    form: {
      name: null,
      description: null,
      selectedVideos: [],
      thumbnail: null
    },
    nameState: null,
    sending: false,
    serverErrors: ""
  }),
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(3)
      },
      description: {
        minLength: minLength(5)
      }
    }
  },
  computed: {
    videos: {
      get() {
        return this.$store.state.client_videos;
      },
      set(value) {
        this.$store.dispatch("updateClientVideos", value);
      }
    }
  },
  mounted() {
    this.$store.dispatch("loadUserVideos");
  },

  created() {
    this.getPlaylist(this.$route.params.id);
  },

  methods: {
    checkFormValidity() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.handleSubmit();
      }
    },

    toggleSelected(video) {
      if (this.form.selectedVideos.some(e => e._id === video._id)) {
        this.form.selectedVideos = this.form.selectedVideos.filter(item => item._id !== video._id);
      } else {
        this.form.selectedVideos.push(video);
      }
    },
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.handleSubmit();
    },

    setThumbnail() {
      this.form.thumbnail = this.form.selectedVideos[0];
    },

    handleSubmit() {
      var playlist = {
        id: this.$route.params.id,
        name: this.form.name,
        description: this.form.description,
        videos: [],
        thumbnail: null
      };

      if (this.form.selectedVideos.length > 0) {
        this.form.selectedVideos.forEach((video, index) => {
          playlist.videos.push({
            video: video._id,
            order: index
          });
        });

        if (this.form.thumbnail == null) {
          playlist.thumbnail = this.form.selectedVideos[0]._id;
          this.setThumbnail();
        } else if (!this.form.selectedVideos.some(video => video._id == this.form.thumbnail._id)) {
          this.setThumbnail();
          playlist.thumbnail = this.form.selectedVideos[0]._id;
        }
      } else {
        this.form.thumbnail = null;
        playlist.thumbnail = null;
      }

      Axios.put(`${process.env.VUE_APP_API_URL}/api/client/playlists`, playlist)
        .then(res => {
          this.$swal.fire({
            position: "center",
            type: "success",
            title: "Changes has been saved!.",
            showConfirmButton: false,
            timer: 1500
          });
          this.$nextTick(() => {
            this.$bvModal.hide("select-videos");
          });
        })
        .catch(error => {
          this.$swal.fire({
            position: "center",
            type: "error",
            title: error.response.data.message,
            showConfirmButton: true
          });
        });
    },
    getPoster(video) {
      if (video == null) return;
      if (video.poster == undefined) {
        return;
      } else {
        return `url('${process.env.VUE_APP_API_URL}/${video.poster}')`;
      }
    },
    getPlaylist(id) {
      Axios.get(`${process.env.VUE_APP_API_URL}/api/client/playlists/${id}`)
        .then(res => {
          this.fillForm(res.data);
          res.data.videos.forEach(video => {
            this.form.selectedVideos.push(video.video);
          });
        })
        .catch(error => {
          console.log(error);
          this.$router.push({ name: "404" });
        });
    },
    getValidationClass(fieldName) {
      const field = this.$v.form[fieldName];
      if (field) {
        return {
          "md-invalid": field.$invalid && field.$dirty
        };
      }
    },
    fillForm(playlist) {
      this.form.name = playlist.name;
      this.form.description = playlist.description;
      this.form.thumbnail = playlist.thumbnail;
    },

    deletePlaylist() {
      this.$swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!"
        })
        .then(result => {
          if (result.value) {
            Axios.delete(`${process.env.VUE_APP_API_URL}/api/client/playlists`, {
              data: { _id: this.$route.params.id }
            })
              .then(() => {
                this.$swal.fire({
                  position: "center",
                  type: "success",
                  title: "PlayList has been deleted.",
                  showConfirmButton: false,
                  timer: 1500
                });
                this.$router.push({ name: "clientPlaylist" });
              })
              .catch(error => {
                this.$swal.fire({
                  position: "center",
                  type: "error",
                  title: "Someting wen't worng!",
                  showConfirmButton: false,
                  timer: 1500
                });
              });
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.play-all-container:hover {
  text-decoration: none !important;
}

.video > div {
  float: left;
}
.playlist-select {
  .list-full {
    margin-bottom: 150px;
    p {
      margin-left: 15px;
      margin-bottom: 3px;
    }
    li:hover {
      cursor: auto;
    }
  }
}

.handle {
  padding: 32px;
}

.handle:hover {
  cursor: move;
}

.play-all-container {
  text-align: center;
  color: #ffffff !important;
  text-transform: uppercase;
  .play-all {
    position: relative;
    height: 200px;
    margin-top: 10px;
    background: rgba($color: gray, $alpha: 0.5);
    background-size: 100% 100% !important;
    background-repeat: no-repeat !important;
    background-position: left top !important;

    .btn-play-all {
      position: absolute;
      z-index: 9999;
      width: 100%;
      bottom: 0;
      left: 0;
      padding: 10px;
      background: rgba($color: #000000, $alpha: 0.5);
    }
  }
}
</style>
